/*import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, A11y } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import OurProduct from "./OurProduct";
import { getProducts } from "../../Services/ProductService";

const OurProductCarousel = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProducts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getProducts({
        isTopSelling: true,
        categoryIds: 1,
        isCustomProduct: false
      });
      if (!response.status) {
        setError(response.message);
        return;
      }
      setProducts(response.products || []);
    } catch (err) {
      setError(err.message || "Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const ac = new AbortController();
    fetchProducts();
    return () => ac.abort();
  }, []);

  useEffect(() => {
    const handleLocationFetched = () => {
      fetchProducts();
    };
    window.addEventListener('locationFetched', handleLocationFetched);
    return () => window.removeEventListener('locationFetched', handleLocationFetched);
  }, []);

  if (loading) {
    return (
      <div className="text-center py-5">
        <p>Loading products...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-5">
        <p className="text-danger">{error}</p>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="text-center py-5">
        <p>No products found.</p>
      </div>
    );
  }

  return (
      <>
          <Swiper
              modules={[Navigation, Pagination, A11y]}
              spaceBetween={30}
              slidesPerView={5}
              navigation
              pagination={{ clickable: true }}
              loop={false}
              breakpoints={{
                  320: {
                      slidesPerView: 2.2,
                  },
                  676: {
                      slidesPerView: 2.5,
                  },
                  991: {
                      slidesPerView: 3.5,
                  },
                  1366: {
                      slidesPerView: 4.5,
                  },
              }}
          >
              {products.map((product, index) => (
                  <SwiperSlide key={product.id || product._id || index}>
                      <OurProduct product={product} />
                  </SwiperSlide>
              ))}
          </Swiper>
      </>
  );
};

export default OurProductCarousel;*/









import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import OurProduct from "./OurProduct";
import { getProducts } from "../../Services/ProductService";

const OurProductCarousel = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProducts = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getProducts({
        isTopSelling: true,
        categoryIds: 1,
        isCustomProduct: false,
      });
      if (!response.status) {
        setError(response.message);
        return;
      }
      setProducts(response.products || []);
    } catch (err) {
      setError(err.message || "Failed to load products");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const ac = new AbortController();
    fetchProducts();
    return () => ac.abort();
  }, []);

  useEffect(() => {
    const handleLocationFetched = () => {
      fetchProducts();
    };
    window.addEventListener("locationFetched", handleLocationFetched);
    return () =>
      window.removeEventListener("locationFetched", handleLocationFetched);
  }, []);

  // ✅ Helper for message buttons
  const renderMessageButton = (message, isClickable = false) => (
    <div className="text-center py-5">
      <button
        onClick={isClickable ? () => window.dispatchEvent(new CustomEvent("openLocationModal")) : undefined}
        style={{
          backgroundColor: "#A37C4D",
          color: "#fff",
          border: "none",
          padding: "10px 24px",
          borderRadius: "6px",
          fontSize: "14px",
          cursor: isClickable ? "pointer" : "default",
        }}
      >
        {message}
      </button>
    </div>
  );

  if (loading) return renderMessageButton("Loading products...");
  if (error) {
    const isLocError = error.toLowerCase().includes("location");
    return renderMessageButton(error, isLocError);
  }
  if (products.length === 0) return renderMessageButton("No products found.");

  return (
    <Swiper
      modules={[Navigation, Pagination, A11y]}
      spaceBetween={30}
      slidesPerView={5}
      navigation
      pagination={{ clickable: true }}
      loop={false}
      breakpoints={{
        320: {
          slidesPerView: 2.2,
        },
        676: {
          slidesPerView: 2.5,
        },
        991: {
          slidesPerView: 3.5,
        },
        1366: {
          slidesPerView: 4.5,
        },
      }}
    >
      {products.map((product, index) => (
        <SwiperSlide key={product.id || product._id || index}>
          <OurProduct product={product} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default OurProductCarousel;

